import {
  Pagination, PaginationContent, PaginationEllipsis, PaginationItem, PaginationLink, PaginationNext, PaginationPrevious,
} from "src/components/ui/pagination";
import { useDashboardSurveyList } from "./useDashboardSurveyList";
import { useMemo } from "react";

const PAGE_GROUP_SIZE = 5;
const DashboardSurveyPagination = () => {
  const {
    isFetching,
    activePage,
    onPageChanged,
    listTotalPages,
    listTotalObjects,
    activeEntity,
  } = useDashboardSurveyList();

  const { previousPages, nextPages } = useMemo(() => {
    return {
      previousPages: Array.from({ length: Math.min(PAGE_GROUP_SIZE, activePage - 1) }, (_, i) => activePage - i - 1).reverse(),
      nextPages: Array.from({ length: Math.min(PAGE_GROUP_SIZE, listTotalPages - activePage) }, (_, i) => activePage + i + 1),
    };
  }, [listTotalPages, activePage]);

  if (listTotalObjects === 0) {
    return null;
  }

  if (isFetching && activeEntity !== 'groups') {
    return null;
  }

  const renderPageEntry = (page: number) => {
    return (
      <PaginationItem
        key={page}
        onClick={() => onPageChanged(page)}
      >
        <PaginationLink>
          {page}
        </PaginationLink>
      </PaginationItem>
    );
  };

  const renderPreviousEndcap = () => {
    if (previousPages.length === 0) {
      return null;
    }

    const shouldRenderOne = previousPages[0] > 1;
    const shouldRenderEllipsis = previousPages[0] > 2;

    return (
      <>
        <PaginationItem>
          <PaginationPrevious onClick={() => onPageChanged(activePage - 1)} />
        </PaginationItem>
        {shouldRenderOne && renderPageEntry(1)}
        {shouldRenderEllipsis && (
          <PaginationItem>
            <PaginationEllipsis />
          </PaginationItem>
        )}
      </>
    );
  };

  const renderNextEndcap = () => {
    if (nextPages.length === 0) {
      return null;
    }

    const shouldRenderLast = nextPages[nextPages.length - 1] < listTotalPages;
    const shouldRenderEllipsis = nextPages[nextPages.length - 1] < listTotalPages - 1;

    return (
      <>
        {shouldRenderEllipsis && (
          <PaginationItem>
            <PaginationEllipsis />
          </PaginationItem>
        )}
        {shouldRenderLast && renderPageEntry(listTotalPages)}
        <PaginationItem>
          <PaginationNext onClick={() => onPageChanged(activePage + 1)} />
        </PaginationItem>
      </>
    );
  };

  return (
    <Pagination>
      <PaginationContent>
        {renderPreviousEndcap()}
        {previousPages.map(renderPageEntry)}
        <PaginationItem>
          <PaginationLink isActive>
            {activePage}
          </PaginationLink>
        </PaginationItem>
        {nextPages.map(renderPageEntry)}
        {renderNextEndcap()}
      </PaginationContent>
    </Pagination>
  );
};

export default DashboardSurveyPagination;
